export default __webpack_public_path__ + "static/media/fold_hospital.9c3fd024.png";